module.exports = __webpack_public_path__ + "static/images/event/steering_wheel.png";